<script lang="ts">
	interface Props {
		tag: string
		color: string
		isSelected?: boolean
		onclick?: () => void
		oncontextmenu?: () => void
	}

	let { tag, color, isSelected, onclick, oncontextmenu }: Props = $props()
</script>

<div
	{onclick}
	{oncontextmenu}
	title={tag}
	class="tag"
	class:selected={isSelected}
	style="background-color: {color}{isSelected ? '' : '44'};"
>
	<div class="selection-indicator"></div>

	<span class="tag-name">
		{tag}
	</span>
</div>

<style>
	.tag {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.tag.selected .selection-indicator {
		opacity: 1;
		position: relative;
	}

	.tag.selected .selection-indicator:after {
		content: "✔";
		color: var(--color-text-light);
		position: absolute;
	}

	.selection-indicator {
		border-radius: 0.2rem;
		width: 0.75rem;
		min-width: 0.75rem;
		height: 0.75rem;
		margin-right: 0.25rem;
		opacity: 0.25;
		background-color: var(--color-bg-dark);
		cursor: pointer;
	}
</style>
